import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-image-help',
  templateUrl: './image-help.component.html',
  styleUrls: ['./image-help.component.scss'],
})
export class ImageHelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
